module.exports = __webpack_public_path__ + "src/assets/img/photo-mr-rx.81b5fb51.png";